document.addEventListener('DOMContentLoaded', function () {
    const configuration = {};
    const body = document.body;

    if (body.dataset.sentryRelease !== undefined) {
        configuration.release = body.dataset.sentryRelease;
    }

    Raven.config(body.dataset.sentryDsn, configuration).install();
});
